import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Calendar, ArrowRight } from 'lucide-react';
import { fetchCollection } from '../../lib/cms';
import SEO from '../../components/SEO';

export default function NyhederDe() {
  const [nyhederList, setNyhederList] = useState([]);

  useEffect(() => {
    async function loadData() {
      const data = await fetchCollection('nyheder', 'de');
      setNyhederList(data);
    }
    loadData();
  }, []);

  return (
    <div className="relative pb-16 md:pb-8 bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Neuigkeiten & Updates - Danshaker"
        description="Lesen Sie die neuesten Nachrichten, Produktverbesserungen und Finanzierungsoptionen von Danshaker."
        path="/de/neuigkeiten"
        lang="de"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Header Section */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-12 md:px-8 md:pt-24">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
            <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
            <span>Aktuelle Meldungen & Wissenswertes</span>
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Neuigkeiten
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed">
            Bleiben Sie informiert über Modell-Updates, neue Farboptionen und attraktive Finanzierungsmöglichkeiten für Ihren Stall.
          </p>
        </div>
      </section>

      {/* News Grid */}
      <section className="mx-auto max-w-7xl px-4 pt-12 pb-0 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {nyhederList.map((item) => (
            <article
              key={item.id}
              className="flex flex-col justify-between rounded-3xl border border-slate-200 bg-white p-8 shadow-xl transition hover:border-[#0E67A2]/30 hover:shadow-2xl"
            >
              <div className="space-y-4">
                <div className="flex items-center gap-2 text-xs font-bold text-slate-500">
                  <Calendar className="h-4 w-4 text-[#0E67A2]" />
                  <span>{item.date}</span>
                </div>
                <h2 className="text-2xl font-bold text-slate-900 leading-snug">
                  {item.title}
                </h2>
                <div
                  className="text-slate-600 text-sm leading-relaxed line-clamp-3 font-medium"
                  dangerouslySetInnerHTML={{ __html: item.content }}
                />
              </div>

              <div className="pt-6 border-t border-slate-100 mt-6">
                <Link
                  to={`/de/neuigkeiten/${item.slug}`}
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#0E67A2] hover:underline"
                >
                  Artikel lesen
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
